import React from "react";
import { Link } from "react-router-dom";
import "../css/main.scss";
import productData from "../Datas/productData";
import ProductCard from "./ProductCard";

function Main() {
  const categories = [
    { label: "New Arrivals", to: "/shop?sort=newest", image: "/main/m-category-new.png" },
    { label: "Signature Denim", to: "/shop?category=Jeans", image: "/main/m-category-denim.png" },
    { label: "Final Sale", to: "/shop?sale=true", image: "/main/m-category-sale.png" },
    { label: "Shop All", to: "/shop", image: "/main/m-category-all.png" },
  ];

  return (
    <main className="home-page">
      <section className="home-hero">
        <img className="home-hero__image" src="/main/m-hero.png" alt="Model wearing an unbranded washed-black barrel jean" />
        <div className="home-hero__content">
          <h1>Solace Barrel Jean</h1>
          <p>Classic barrel, elevated</p>
          <Link to="/products/3">Shop</Link>
        </div>
        <div className="home-hero__dots" aria-label="Hero slide 1 of 2"><span className="active" /><span /></div>
      </section>

      <section className="home-products page-section">
        <div className="section-heading">
          <h2>New Arrivals</h2>
          <Link to="/shop?sort=newest">Shop New Arrivals</Link>
        </div>
        <div className="home-products__rail">
          {productData.slice(0, 8).map((product, index) => <ProductCard key={product.id} product={product} priority={index < 4} />)}
        </div>
      </section>

      <section className="editorial-grid page-section page-section--flush">
        <Link className="editorial-card" to="/about">
          <img src="/main/m-editorial.png" alt="Two models in an architectural setting wearing unbranded denim" />
          <div><h2>nartvmora studio</h2><p>Designed with intention.</p><span>Explore</span></div>
        </Link>
        <Link className="editorial-card" to="/about">
          <img src="/main/m-craft.png" alt="Maker checking the drape of indigo fabric in a studio" />
          <div><h2>Our craft</h2><p>Considered from fibre to finish.</p><span>Explore</span></div>
        </Link>
      </section>

      <section className="category-section page-section">
        <div className="section-heading"><h2>Shop the edit</h2></div>
        <div className="category-grid">
          {categories.map((category) => (
            <Link to={category.to} className="category-card" key={category.label}>
              <img src={category.image} alt="" />
              <span>{category.label}</span>
            </Link>
          ))}
        </div>
      </section>

      <section className="home-story page-section">
        <div className="home-story__image"><img src="/main/m-story.png" alt="Craftsperson arranging denim swatches at a studio table" /></div>
        <div className="home-story__copy">
          <p className="eyebrow">Designed with purpose. Made responsibly.</p>
          <h2>nartvmora</h2>
          <p>nartvmora approaches denim from the details up. We make enduring silhouettes that pair understated ease with confident femininity — pieces designed for repeat wear, not a single season.</p>
          <p>Our focus remains clear: precise fit, premium materials and responsible manufacturing choices that respect the people who make our clothes and the way our customers live in them.</p>
          <Link to="/about" className="text-link">Discover our story</Link>
        </div>
      </section>

      <section className="home-values" aria-label="Our commitments">
        <div><strong>Fit that works</strong><span>Designed for real wardrobes and repeat wear.</span></div>
        <div><strong>Premium materials</strong><span>Denim selected for structure, comfort and longevity.</span></div>
        <div><strong>Considered making</strong><span>Responsible choices, transparent progress.</span></div>
      </section>
    </main>
  );
}

export default Main;
